import api from '../../../lib/Api'
import * as actions from './actions'
import { addNotification } from '../../notifications'

export const onFileChange = event => {
  return async function(dispatch) {
    const file = event.target.files[0]
    dispatch(actions.setSelectedFile(file))
  }
}

export const handlePacingUpload = file => {
  return async function(dispatch) {
    dispatch(actions.setIsSubmitting())
    const bodyFormData = new FormData()
    bodyFormData.set('file', file)

    try {
      const response = await api.patch('sites/pacing', bodyFormData)
      const data = response.data
      dispatch(actions.setPacingSuccess(data))
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully submitted pacing dates',
        }),
      )
    } catch (error) {
      const errorMsg =
        error.response && error.response.status === 400
          ? error.response.data.detail
          : "Something's gone wrong while uploading file. Please try again or file a ticket for assistance."
      dispatch(actions.setPacingError(errorMsg))

      dispatch(
        addNotification({
          color: 'danger',
          text: errorMsg,
        }),
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/pacing/operations.js